import { useContext } from "react";
import { useSelector } from "react-redux";

import { CompanyNameContext, WelcomeTutorialStep } from "routes/welcome-tutorial/helpers";
import { selectIsAdmin } from "store/entities/agents";
import { selectAreMailboxesSetUp } from "store/entities/email-domains";
import { selectSkipStandaloneAppTutorialInviteTeammatesStep } from "store/views/welcome-tutorial";

export const useWelcomeTutorialSteps = (): WelcomeTutorialStep[] => {
  const wasCompanyNameSet = useContext(CompanyNameContext);
  const isAdmin = useSelector(selectIsAdmin);
  const isForwardingSetUp = useSelector(selectAreMailboxesSetUp);
  const skipInviteTeammatesStep = useSelector(selectSkipStandaloneAppTutorialInviteTeammatesStep);

  return isAdmin
    ? getAdminTutorialSteps(wasCompanyNameSet, isForwardingSetUp, skipInviteTeammatesStep)
    : getUserTutorialSteps(isForwardingSetUp, skipInviteTeammatesStep);
};

const getAdminTutorialSteps = (
  wasCompanyNameSet: boolean,
  isForwardingSetUp: boolean,
  skipInviteStep: boolean
): WelcomeTutorialStep[] => {
  let stepsToDisplay: Array<WelcomeTutorialStep> = [];

  if (!wasCompanyNameSet) stepsToDisplay = [...stepsToDisplay, WelcomeTutorialStep.Mailbox];
  if (!skipInviteStep) stepsToDisplay = [...stepsToDisplay, WelcomeTutorialStep.Invite];
  if (!isForwardingSetUp) stepsToDisplay = [...stepsToDisplay, WelcomeTutorialStep.Forwarding];

  return stepsToDisplay;
};

const getUserTutorialSteps = (isForwardingSetUp: boolean, skipInviteStep: boolean): WelcomeTutorialStep[] => {
  let stepsToDisplay: Array<WelcomeTutorialStep> = [];

  if (!skipInviteStep) stepsToDisplay = [...stepsToDisplay, WelcomeTutorialStep.Invite];
  if (!isForwardingSetUp) stepsToDisplay = [...stepsToDisplay, WelcomeTutorialStep.Forwarding];

  return stepsToDisplay;
};
